<h1 i18n>Gebruikersinstellingen</h1>

<p i18n>Verander je (gebruikers)naam of wachtwoord.</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    @if (form.controls.username; as control) {
    <div>
        <label for="username" class="form-label" i18n>Gebruikersnaam</label>
        <input
            type="text"
            id="username"
            autocomplete="username"
            class="form-control"
            [class.is-invalid]="control.touched && control.invalid"
            [formControl]="control"
        />
        @for (error of usernameErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div>
        <label for="first-name" class="form-label" i18n>Voornaam</label>
        <input
            type="text"
            id="first-name"
            autocomplete="given-name"
            class="form-control"
            [class.is-invalid]="
                form.controls.firstName.touched &&
                form.controls.firstName.invalid
            "
            [formControl]="form.controls.firstName"
        />
    </div>
    <div>
        <label for="last-name" class="form-label" i18n>Achternaam</label>
        <input
            type="text"
            id="last-name"
            autocomplete="family-name"
            class="form-control"
            [class.is-invalid]="
                form.controls.lastName.touched && form.controls.lastName.invalid
            "
            [formControl]="form.controls.lastName"
        />
    </div>
    @for (error of formErrors$ | async; track $index) {
    <p class="invalid-feedback always-block">
        {{ error }}
    </p>
    }
    <div
        class="d-flex flex-wrap justify-content-start align-items-center button-row mt-3"
    >
        <button type="submit" class="btn btn-primary">
            <span i18n>Wijzigingen opslaan</span>
            @if (updateSettingsLoading$ | async) {
            <div class="spinner-border spinner-border-sm ms-1" role="status">
                <span class="visually-hidden" i18n>
                    Opslaan...
                </span>
            </div>

            }
        </button>
        <button
            class="btn btn-primary"
            type="button"
            (click)="requestPasswordReset()"
        >
            <span i18n>Verzoek nieuw wachtwoord</span>
            @if (requestResetLoading$ | async) {
            <div class="spinner-border spinner-border-sm ms-1" role="status">
                <span class="visually-hidden" i18n>
                    Verzoeken...
                </span>
            </div>
            }
        </button>
        <button class="btn btn-danger" type="button" (click)="deleteAccount()">
            <span i18n>Account opzeggen</span>
            @if (deleteUserLoading$ | async) {
            <div class="spinner-border spinner-border-sm ms-1" role="status">
                <span class="visually-hidden" i18n>Opzeggen...</span>
            </div>
            }
        </button>
    </div>
    }
</form>
